export enum PrimerSelectNodeTypeEnum {
    PARENT_NODE = 'parent-node',
    CHILD_NODE = 'child-node',
}
